import dsjain from 'images/consultancy_images/dsjain.png'
import dajain from 'images/consultancy_images/dajain.jpeg'
import sunitajain from 'images/consultancy_images/sunitajain.jpeg'
import swastimishra from 'images/consultancy_images/swasti-mishra.jpeg'
import drjain from 'images/consultancy_images/drjain.jpeg'

export const teamMembers = [
    {
        id: "dr-suresh-jain",
        name: "Dr. Suresh Jain",
        image: dsjain,
        details: [
            "Certified Naturopathy Doctor (NDDY)",
            [
                {text: "25 years", bold: true},
                {text: " of experience in Natural Healing"}
            ]
        ]
    },
    {
        id: "dr-ashish-jain",
        name: "Yogacharya Dr. Ashish Jain",
        image: dajain,
        details: [
            {text: "Certified Yoga Teacher", bold: true},
            [
                {text: "10 years", bold: true},
                {text: " of experience in teaching Yoga"}
            ],
            "Head of Balak Vidyarthi Grah, Amayan Bhind"
        ]
    },
    {
        id: "sunita-jain",
        name: "Yogacharya Sunita Jain",
        image: sunitajain,
        details: [
            {text: "Certified Yoga Teacher", bold: true},
            [
                {text: "20 years", bold: true},
                {text: " of experience in "},
                {text: "Acupressure, Sujok, Magnet Therapy, Yoga, Pranayama & Naturopathy"}
            ]
        ]
    },
    {
        id: "swasti-mishra",
        name: "Swasti Mishra",
        image: swastimishra,
        details: [
            "Architecture & Interior Design",
            {text: "Architect, Interior Designer & Planner", bold: true},
            [
                {text: "20 years", bold: true},
                {text: " of experience as an Architect, Interior Designer, Planner"}
            ]
        ]
    },
    {
        id: "rohit-jain",
        name: "Rohit Jain",
        image: drjain,
        details: [
            [
                {text: "Founder,"},
                {text: " Banyan Roots Organics Pvt. Ltd.", bold: true}
            ],
            {text: "Sustainable Mud House Consultant", bold: true},
            [
                {text: "14 years", bold: true},
                {text: " of experience as an Organic Farmpreneur"}
            ]
        ]
    },
    {
        id: "dr-pragati-jain",
        name: "Dr. Pragati Jain",
        image: '/images/prgati_jain.png',
        details: [
            {text: "Founder, Anuyog", bold: true},
            [
                {text: "Ph.D in"},
                {text: " Computational Neuroscience", bold: true},
            ],
            [
                {text: "15 years", bold: true},
                {text: " of experience in Artificial Intelligence"}
            ]
        ]
    }
];
